import React from 'react';

const MemberAppointmentLayout = React.lazy(() => import('./MemberAppointmentLayout'))
const MemberAppointmentDefaultPage = React.lazy(() => import('./MemberAppointmentDefaultPage'))

export default {
  path: '/:channel/video-consultation',
  name: 'Video Consultation',
  component: MemberAppointmentLayout,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: MemberAppointmentDefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/remote-therapy/memberRoute.js